// extracted by mini-css-extract-plugin
export default {"list":"AddMenuItemsList_list__3-4bf"};